// import React, { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import { FetchPublicProvidersDetail } from "../../../api/helper";

// const ProviderViewDetails = () => {
// const location = useLocation();
// const providerId = location.state?.providerId;
// const [providerInfo, setProviderInfo] = useState(null);
// const [loading, setLoading] = useState(true);

//   const GetProviderDetail = async () => {
//     try {
//       const res = await FetchPublicProvidersDetail(providerId);
//       setProviderInfo(res?.data?.data);
//     } catch (error) {
//       console.error("Error fetching provider details:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (providerId) {
//       GetProviderDetail();
//     }
//   }, [providerId]);
// useEffect(() => {
//   window.scrollTo({ top: 0, behavior: "smooth" });
// }, []);
//   if (loading) return <div className="text-center mt-20 text-gray-500 text-lg">Loading...</div>;
//   if (!providerInfo) return <div className="text-center mt-20 text-red-500 text-lg">No provider data found.</div>;

// const formatNames = (arr, key = "name") =>
//   Array.isArray(arr) && arr.length > 0
//     ? arr.map((item) => (typeof item === "string" ? item : item[key])).join(", ")
//     : "Not Available";

//   const excludedKeys = new Set([
//     "image", "firstName", "lastName", "ServiceType", "DeliveryMode", "LicenseType", "address",
//     "LanguagesId", "info", "phone", "email", "gender", "DOB", "availableDays", 'isVerified', '_id',
//     'status', 'patientId','agencyId', 'categoryId', 'slots', 'degreeTypeId', 'toggleOnOff', 'treatmentTypeId',
//     'ModalitiesId', 'PopulationServedId', 'createdAt', 'updatedAt', '__v', 'Insurance', 'Specialties', 'TreatmentTypeId',
//   ]);

//   const renderOtherFields = () => {
//     return Object.entries(providerInfo)
//       .filter(([key, value]) => {
//         if (excludedKeys.has(key)) return false;
//         if (value === null || value === undefined || value === "") return false;
//         if (typeof value === "object") {
//           if (Array.isArray(value)) {
//             return value.every((v) => typeof v === "string" || typeof v === "number");
//           }
//           return false;
//         }
//         return true;
//       })
//       .map(([key, value]) => (
//         <div key={key} className="text-gray-700">
//           <span className="font-semibold">{key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}:</span>{" "}
//           {Array.isArray(value) ? value.join(", ") (value)}
//         </div>
//       ));
//   };

//   return (
//     <div className="max-w-7xl mx-auto px-4 py-8">
//       {/* Header */}
//       <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">Doctor Details</h2>

//       {/* Main Info */}
//       <div className="bg-white rounded-xl shadow-lg p-6 md:flex md:space-x-6">
//         {/* Image */}
//         <div className="flex-shrink-0 mb-4 md:mb-0">
//           <img
//             className="w-40 h-40 object-cover rounded-full border-4 border-indigo-500 shadow-md"
//             src={
//               providerInfo?.image
//                 ? providerInfo.image
//                 : require("../../assest/Images/doctorimg.png")
//             }
//             alt="Doctor"
//           />
//         </div>

//         {/* Info */}
//         <div className="flex-1">
//           <h3 className="text-2xl font-bold text-gray-800 mb-2">
//             Dr. {providerInfo?.firstName} {providerInfo?.lastName}
//           </h3>
//           <div className="flex flex-wrap gap-4 text-gray-700 mt-2">
//             <div><span className="font-semibold">Service Type:</span> {formatNames(providerInfo?.ServiceType)}</div>
//             <div><span className="font-semibold">Delivery Mode:</span> {formatNames(providerInfo?.DeliveryMode)}</div>
//             <div><span className="font-semibold">License Type:</span> {providerInfo?.LicenseType || "Not Available"}</div>
//             <div><span className="font-semibold">License In:</span> {providerInfo?.address?.state || "Not Available"}</div>
//             <div><span className="font-semibold">Languages:</span> {formatNames(providerInfo?.LanguagesId)}</div>
//           </div>
//           <div className="mt-4">
//             <span className="font-semibold">Short Biography:</span> {providerInfo?.info || "No biography available."}
//           </div>
//         </div>

//         {/* Contact Info */}
//         <div className="mt-4 md:mt-0 md:text-right">
//           <div><span className="font-semibold">Phone:</span> {providerInfo?.phone || "Not Available"}</div>
//           <div><span className="font-semibold">Email:</span> {providerInfo?.email || "Not Available"}</div>
//           <div><span className="font-semibold">Gender:</span> {providerInfo?.gender || "Not Specified"}</div>
//           <div>
//             <span className="font-semibold">DOB:</span>{" "}
//             {providerInfo?.DOB ? new Date(providerInfo.DOB).toLocaleDateString() : "Not Available"}
//           </div>
//         </div>
//       </div>

//       {/* Tabs */}
//       <div className="mt-10">
//         <div className="flex border-b border-gray-300 mb-6">
//           <div className="py-2 px-4 border-b-2 border-indigo-500 text-indigo-600 font-semibold">Basic Information</div>
//         </div>

//         {/* Availability */}
//         <div className="bg-white p-6 rounded-xl shadow-md mb-10">
//           <h4 className="text-xl font-semibold text-gray-800 mb-4 border-b border-gray-300 pb-2">Availability</h4>
//           {providerInfo?.availableDays?.availableDays?.length > 0 ? (
//             <ul className="space-y-3 text-gray-700">
//               {providerInfo.availableDays.availableDays.map((dayObj) => (
//                 <li key={dayObj.day} className="flex flex-wrap items-center">
//                   <strong className="w-24 text-gray-900">{dayObj.day}:</strong>
//                   <div className="flex flex-wrap gap-2">
//                     {dayObj.shifts.map((shift, index) => (
//                       <span
//                         key={index}
//                         className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-medium"
//                       >
//                         {shift.startTime} - {shift.endTime}
//                       </span>
//                     ))}
//                   </div>
//                 </li>
//               ))}
//             </ul>
//           ) : (
//             <p className="text-gray-500 italic">No availability data.</p>
//           )}
//         </div>

//         {/* Other Basic Information */}
//         <div className="bg-white p-6 rounded-xl shadow-md">
//           <h4 className="text-xl font-semibold text-gray-800 mb-4 border-b border-gray-300 pb-2">Other Basic Information</h4>
//           {renderOtherFields().length > 0 ? (
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
//               {renderOtherFields().map((field, index) => (
//                 <div key={index} className="bg-gray-50 p-4 rounded-xl border border-gray-200 shadow-sm">
//                   {field}
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <p className="text-gray-500 italic">No additional information available.</p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProviderViewDetails;
import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Separator } from './ui/separator';
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { Input } from './ui/input';
import {
  ArrowLeft,
  Star,
  MapPin,
  Phone,
  Mail,
  Calendar,
  Video,
  Clock,
  GraduationCap,
  Shield,
  Heart,
  Brain,
  Stethoscope,
  CheckCircle,
  Users,
  Award,
  BookOpen,
  MessageSquare,
  Globe,
  CreditCard,
  Building,
  FileText,
  ThumbsUp,
  ChevronRight,
  ExternalLink,
  ArrowRight,
  Check
} from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/Button';
import { Badge } from './ui/badge';
import { FetchPublicProvidersDetail } from '../../../api/helper';


const appointmentTypes = [
  { value: 'initial', label: 'Initial Consultation', duration: '60 min', price: '$200' },
  { value: 'followup', label: 'Follow-up Appointment', duration: '30 min', price: '$120' },
  { value: 'medication', label: 'Medication Management', duration: '30 min', price: '$120' },
  { value: 'therapy', label: 'Therapy Session', duration: '50 min', price: '$180' },
  { value: 'crisis', label: 'Crisis Consultation', duration: '30 min', price: '$150' }
];

const paymentTypes = [
  { value: 'insurance', label: 'Insurance Coverage' },
  { value: 'private', label: 'Private Pay' },
  { value: 'subscription', label: 'Monthly Subscription' }
];

const usStates = [
  { value: 'FL', label: 'Florida' },
  { value: 'NY', label: 'New York' },
  { value: 'CA', label: 'California' },
  { value: 'TX', label: 'Texas' },
  { value: 'IL', label: 'Illinois' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'OH', label: 'Ohio' },
  { value: 'GA', label: 'Georgia' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'MI', label: 'Michigan' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'IN', label: 'Indiana' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MD', label: 'Maryland' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'CO', label: 'Colorado' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'AL', label: 'Alabama' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'OR', label: 'Oregon' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'UT', label: 'Utah' }
];

const ProviderViewDetails = () => {
  const location = useLocation();
  const providerId = location.state?.providerId;
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [provider, setProvider] = useState(null);
  const [selectedTab, setSelectedTab] = useState('about');
  const [showAllReviews, setShowAllReviews] = useState(false);
  const [selectedTime, setSelectedTime] = useState('');
  const [selectedDay, setSelectedDay] = useState('');
  const [appointmentType, setAppointmentType] = useState('');
  const [paymentType, setPaymentType] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [reasonForVisit, setReasonForVisit] = useState('');
  const [showBookingDialog, setShowBookingDialog] = useState(false);
  const [clientName, setClientName] = useState('');
  const [clientEmail, setClientEmail] = useState('');
  const [clientPhone, setClientPhone] = useState('');
  const [clientDOB, setClientDOB] = useState('');

  const GetProviderDetail = async () => {
    try {
      const res = await FetchPublicProvidersDetail(providerId);
      console.log(res?.data?.data)
      setProvider(res?.data?.data);
    } catch (error) {
      console.error("Error fetching provider details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (providerId) {
      GetProviderDetail();
    }
  }, [providerId]);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  if (!provider) {
    return (
      <div className="min-h-screen bg-gray-50 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">Provider Not Found</h1>
            <p className="text-gray-600 mb-6">The provider you're looking for could not be found.</p>
            <Button onClick={() => navigate('/providers')}>
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Provider Directory
            </Button>
          </div>
        </div>
      </div>
    );
  }


  const handleBookAppointment = async () => {
    setLoading(true);

    // Simulate account creation and booking process
    await new Promise(resolve => setTimeout(resolve, 2000));

    setLoading(false);
    setShowBookingDialog(false);

    // Show account creation message
    toast.success('Account Created Successfully!', {
      description: 'Please log in to confirm your appointment and access your patient portal',
      duration: 5000,
      action: {
        label: 'Login Now',
        onClick: () => navigate('/login')
      }
    });

    // Reset form
    setSelectedDay('');
    setSelectedTime('');
    setAppointmentType('');
    setPaymentType('');
    setSelectedState('');
    setReasonForVisit('');
    setClientName('');
    setClientEmail('');
    setClientPhone('');
    setClientDOB('');

    // Redirect to login after a brief delay
    setTimeout(() => {
      navigate('/login');
    }, 3000);
  };

  const displayedReviews = showAllReviews ? provider.reviews : provider.reviews?.slice(0, 3);
  const formatNames = (arr, key = "name") =>
    Array.isArray(arr) && arr.length > 0
      ? arr.map((item) => (typeof item === "string" ? item : item[key])).join(", ")
      : "Not Available";
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b border-gray-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 py-3">
          <Button variant="ghost" onClick={() => navigate('/providers')} className="text-gray-600 hover:text-gray-900">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Provider Directory
          </Button>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-1 space-y-6">
            <Card className="overflow-hidden">
              <div class="gradient-header"></div>

              <CardContent className="pt-0 px-6 pb-6">
                <div className="relative">
                  <Avatar className="w-24 h-24 border-4 border-white shadow-lg -mt-12 mb-4">
                    <AvatarImage src={provider?.image} alt={`${provider?.firstName} ${provider?.lastName}`} className="object-cover" />
                    <AvatarFallback className="text-xl bg-clinic-blue-100 text-clinic-blue-600">
                      {provider?.firstName?.[0]}{provider?.lastName?.[0]}
                    </AvatarFallback>
                  </Avatar>
                </div>

                <h1 className="text-xl font-bold text-gray-900 mb-1">
                  {provider?.firstName && provider?.lastName
                    ? `${provider.firstName} ${provider.lastName}`
                    : "Provider Name"}
                </h1>

                <h2 className="text-clinic-blue-600 mb-2" style={{ textAlign: 'left' }}>Therapist</h2>

                <p className="text-sm text-gray-600 mb-1" style={{ textAlign: 'left' }}>M.S. Clinical Psychology</p>

                <p className="text-sm text-gray-500 mb-3" style={{ textAlign: 'left' }}>
                  {provider?.address?.city ? `${provider.address.city}, ` : ""}
                  {provider?.address?.state || "Location"}
                </p>

                <div className="flex items-center mb-4">
                  <Star className="w-4 h-4 fill-current text-yellow-400 mr-1" />
                  <span className="font-medium text-sm">4.5</span>
                  <span className="text-sm text-gray-500 ml-1">(120 reviews)</span>
                </div>

                <div className="space-y-2">
                  <Button asChild className="w-full bg-clinic-blue-600 hover:bg-clinic-blue-700">
                    <Link to="/booking/telehealth" state={{ providerId: provider?._id }}>
                      <Calendar className="w-4 h-4 mr-2" />
                      Book Appointment
                    </Link>
                  </Button>
                  <Button variant="outline" className="w-full border-clinic-blue-600 text-clinic-blue-600 hover:bg-clinic-blue-50">
                    <MessageSquare className="w-4 h-4 mr-2" />
                    Send Message
                  </Button>
                </div>
              </CardContent>
            </Card>


            <Card className="mb-4">
              <CardHeader>
                <CardTitle>Service Information</CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                {provider?.ServiceType?.length > 0 && (
                  <div>
                    <h4 className="font-medium" style={{ textAlign: 'left' }}>Service Type :</h4>
                    <p style={{ textAlign: 'left' }}>{provider.ServiceType.map(s => s.name).join(", ")}</p>
                  </div>
                )}

                {provider?.DeliveryMode?.length > 0 && (
                  <div>
                    <h4 className="font-medium" style={{ textAlign: 'left' }}>Delivery Mode :</h4>
                    <p style={{ textAlign: 'left' }}>{provider.DeliveryMode.map(d => d.name).join(", ")}</p>
                  </div>
                )}

                {provider?.LicenseType && (
                  <div>
                    <h4 className="font-medium">License Type</h4>
                    <p>{provider.LicenseType}</p>
                  </div>
                )}

                {provider?.stateOfPractice?.length > 0 && (
                  <div>
                    <h4 className="font-medium" style={{ textAlign: 'left' }}>States Licensed In :</h4>
                    <p style={{ textAlign: 'left' }}>{provider.stateOfPractice.join(", ")}</p>
                  </div>
                )}
              </CardContent>
            </Card>

            <Card>
              <CardHeader className="pb-4">
                <CardTitle className="text-lg flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-600 mr-2" />
                  Availability Status
                </CardTitle>
              </CardHeader>

              <CardContent className="space-y-3">
                <div className="flex flex-col space-y-2">
                  {provider.AvailabilityStatus?.length > 0 ? (
                    provider.AvailabilityStatus.map((status, idx) => {
                      if (status === "Accepting New Clients") {
                        return (
                          <Badge
                            key={idx}
                            className="bg-green-100 text-green-700 border-green-200 justify-start"
                          >
                            <CheckCircle className="w-3 h-3 mr-1" />
                            Accepting New Clients
                          </Badge>
                        );
                      }
                      if (status === "Telehealth Available") {
                        return (
                          <Badge
                            key={idx}
                            className="bg-blue-100 text-blue-700 border-blue-200 justify-start"
                          >
                            <Video className="w-3 h-3 mr-1" />
                            Telehealth Available
                          </Badge>
                        );
                      }
                      return (
                        <Badge
                          key={idx}
                          className="bg-gray-100 text-gray-700 border-gray-200 justify-start"
                        >
                          <CheckCircle className="w-3 h-3 mr-1" />
                          {status}
                        </Badge>
                      );
                    })
                  ) : (
                    null
                  )}

                  {provider.nextAvailable &&
                    !isNaN(new Date(provider.nextAvailable).getTime()) && (
                      <Badge className="bg-yellow-100 text-yellow-700 border-yellow-200 justify-start">
                        <Clock className="w-3 h-3 mr-1" />
                        Next: {new Date(provider.nextAvailable).toLocaleDateString()}
                      </Badge>
                    )}

                  {provider.availableDays?.availableDays?.length > 0 && (
                    <div className="space-y-2">
                      {provider.availableDays.availableDays.map((dayObj, idx) => (
                        <div key={idx} className="flex flex-col">
                          <span className="font-medium text-sm flex items-center">
                            <Calendar className="w-3 h-3 mr-1 text-gray-600" />
                            {dayObj.day}
                          </span>
                          <div className="flex flex-wrap gap-2 mt-1">
                            {dayObj.shifts.map((shift, sIdx) => (
                              <Badge
                                key={sIdx}
                                className="bg-purple-100 text-purple-700 border-purple-200"
                              >
                                {shift.startTime} - {shift.endTime}
                              </Badge>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardHeader className="pb-4">
                <CardTitle className="text-lg flex items-center">
                  <Globe className="w-5 h-5 text-clinic-blue-600 mr-2" />
                  Languages & Insurance
                </CardTitle>
              </CardHeader>

              <CardContent className="space-y-4">
                <div>
                  <h4 className="font-medium text-gray-900 text-sm mb-2" style={{ textAlign: 'left' }}>Languages :</h4>
                  <div className="flex flex-wrap gap-1">
                    {provider?.LanguagesId && provider.LanguagesId.length > 0 ? (
                      provider.LanguagesId.map((lang, index) => (
                        <Badge
                          key={lang._id || index}
                          variant="secondary"
                          className="bg-gray-100 text-gray-700 text-xs"
                        >
                          {lang.name}
                        </Badge>
                      ))
                    ) : (
                      <p className="text-xs text-gray-500">No languages available</p>
                    )}
                  </div>
                </div>

                <div>
                  <h4 className="font-medium text-gray-900 text-sm mb-2" style={{ textAlign: 'left' }}>Insurance Accepted :</h4>
                  <div className="text-xs text-gray-600">
                    {provider?.Insurance && provider.Insurance.length > 0 ? (
                      <>
                        {/* <p>{provider.Insurance.slice(0, 3).join(", ")}</p>
                        {provider.Insurance.length > 3 && (
                          <p className="text-clinic-blue-600 cursor-pointer">
                            + {provider.Insurance.length - 3} more
                          </p>
                        )} */}
                        <p className="text-xs text-gray-500" style={{ textAlign: 'left' }}>No insurance information</p>
                      </>
                    ) : (
                      <p className="text-xs text-gray-500" style={{ textAlign: 'left' }}>No insurance information</p>
                    )}
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
          <div className="lg:col-span-2">
            <Tabs value={selectedTab} onValueChange={setSelectedTab} className="space-y-6">
              <TabsList className="grid w-full grid-cols-7">
                <TabsTrigger value="about">About</TabsTrigger>
                <TabsTrigger value="experience">Experience</TabsTrigger>
                <TabsTrigger value="approach">Approach</TabsTrigger>
                <TabsTrigger value="availability">Schedule</TabsTrigger>
                <TabsTrigger value="payment">Payment</TabsTrigger>
                <TabsTrigger value="reviews">Reviews</TabsTrigger>
                <TabsTrigger value="contact">Contact</TabsTrigger>
              </TabsList>
              <TabsContent value="about" className="space-y-6">
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center">
                      <Users className="w-5 h-5 text-clinic-blue-600 mr-2" />
                      Professional Overview
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-gray-600">{provider.info}</p>
                  </CardContent>
                </Card>
                <div className="grid md:grid-cols-2 gap-6">
                  {/* <Card className="card-overflow-hidden">
                    <div className="card-header-gradient">
                      <div className="card-header-content">
                        <Award className="card-header-icon" />
                        <h3 className="card-header-title">Specializations</h3>
                      </div>
                      <p className="card-header-subtitle">
                        {((provider.Specialization && provider.Specialization.length > 0) ||
                          (provider.Specialties && provider.Specialties.length > 0))
                          ? "Areas of expertise and clinical focus"
                          : ""}
                      </p>
                    </div>

                    <CardContent className="card-content">
                      <div className="badge-container">
                        {provider?.Specialization?.length > 0 ? (
                          provider.Specialization.map((spec, index) => (
                            <Badge key={index} className="badge-secondary">
                              {spec}
                            </Badge>
                          ))
                        ) : provider?.Specialties?.length > 0 ? (
                          provider.Specialties.map((spec, index) => (
                            <Badge key={spec._id || index} className="badge-secondary">
                              {spec.name}
                            </Badge>
                          ))
                        ) : (
                          <p style={{ color: "#7a5d00", fontStyle: "italic" }}>
                            This provider has not listed any specializations yet.
                          </p>
                        )}
                      </div>
                    </CardContent>
                  </Card>

                  <Card className="overflow-hidden">
                    <div className="bg-gradient-to-r from-purple-500 to-purple-600 p-6 text-white">
                      <div className="flex items-center mb-2">
                        <Brain className="w-6 h-6 text-white mr-3" />
                        <h3 className="text-xl font-semibold">Treatment Approaches</h3>
                      </div>
                      <p className="text-purple-50 text-sm">
                        Evidence-based therapeutic methods used
                      </p>
                    </div>
                    <CardContent className="p-6">
                      <div className="flex flex-wrap gap-2">
                        {provider.treatmentApproaches?.map((approach, index) => (
                          <Badge key={index} variant="outline" className="border-purple-200 text-purple-700 bg-purple-50">
                            {approach}
                          </Badge>
                        ))}
                      </div>
                    </CardContent>
                  </Card>

                  <Card className="overflow-hidden">
                    <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 text-white">
                      <div className="flex items-center mb-2">
                        <Users className="w-6 h-6 text-white mr-3" />
                        <h3 className="text-xl font-semibold">Age Groups</h3>
                      </div>
                      <p className="text-green-50 text-sm">
                        Patient populations served and treated
                      </p>
                    </div>
                    <CardContent className="p-6">
                      <div className="flex flex-wrap gap-2">
                        {provider.ageGroups?.map((group, index) => (
                          <Badge key={index} variant="outline" className="border-green-200 text-green-700 bg-green-50">
                            {group}
                          </Badge>
                        ))}
                      </div>
                    </CardContent>
                  </Card> */}

                  <Card className="conditions-card">
                    <div className="conditions-card-header">
                      <div className="conditions-card-header-content">
                        <Stethoscope className="conditions-card-icon" />
                        <h3 className="conditions-card-title">Conditions Treated</h3>
                      </div>
                      <p className="conditions-card-subtitle">
                        {provider?.ConditionTreatedId?.length > 0
                          ? "Mental health conditions and disorders"
                          : "No conditions available"}
                      </p>
                    </div>

                    <CardContent className="conditions-card-content">
                      <div className="conditions-badge-container">
                        {provider?.ConditionTreatedId?.length > 0 ? (
                          provider.ConditionTreatedId.map((condition, index) => (
                            <Badge key={condition._id || index} className="conditions-badge">
                              {condition.name}
                            </Badge>
                          ))
                        ) : (
                          <p className="conditions-empty">This provider has not listed any conditions yet.</p>
                        )}
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </TabsContent>

              <TabsContent value="experience" className="space-y-6">
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center">
                      <GraduationCap className="w-5 h-5 text-clinic-blue-600 mr-2" />
                      Professional Experience{" :  "}<span>{" " + provider.experience} years</span>
                    </CardTitle>
                  </CardHeader>
                </Card>

              </TabsContent>

              <TabsContent value="approach" className="space-y-6">
                <div className="grid gap-6">
                  <Card>
                    <CardHeader>
                      <CardTitle className="flex items-center">
                        <Heart className="w-5 h-5 text-red-600 mr-2" />
                        A Little About Me
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      <p className="text-gray-600 leading-relaxed">{provider.shortBiography}</p>
                    </CardContent>
                  </Card>

                  <Card>
                    <CardHeader>
                      <CardTitle className="flex items-center">
                        <Brain className="w-5 h-5 text-purple-600 mr-2" />
                        My Approach to Care
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      <p className="text-gray-600 leading-relaxed">{provider.myApproach}</p>
                    </CardContent>
                  </Card>

                  <Card>
                    <CardHeader>
                      <CardTitle className="flex items-center">
                        <Stethoscope className="w-5 h-5 text-clinic-blue-600 mr-2" />
                        My Focus
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      <p className="text-gray-600 leading-relaxed">{provider.myFocus}</p>
                    </CardContent>
                  </Card>

                  <Card>
                    <CardHeader>
                      <CardTitle className="flex items-center">
                        <MessageSquare className="w-5 h-5 text-green-600 mr-2" />
                        My Communication Style
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      <p className="text-gray-600 leading-relaxed">{provider.myCommunicationStyle}</p>
                    </CardContent>
                  </Card>

                  <Card>
                    <CardHeader>
                      <CardTitle className="flex items-center">
                        <MapPin className="w-5 h-5 text-clinic-gold-600 mr-2" />
                        My Journey to Mental Healthcare
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      <p className="text-gray-600 leading-relaxed">{provider.myJourneyToMentalHealthcare}</p>
                    </CardContent>
                  </Card>

                  <Card>
                    <CardHeader>
                      <CardTitle className="flex items-center">
                        <Award className="w-5 h-5 text-clinic-gold-600 mr-2" />
                        My Goals for You
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      <p className="text-gray-600 leading-relaxed">{provider.myGoalsForYou}</p>
                    </CardContent>
                  </Card>

                  <Card>
                    <CardHeader>
                      <CardTitle className="flex items-center">
                        <Calendar className="w-5 h-5 text-clinic-blue-600 mr-2" />
                        My First Session with You
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      <p className="text-gray-600 leading-relaxed">{provider.myFirstSessionWithYou}</p>
                    </CardContent>
                  </Card>
                </div>
              </TabsContent>

              <TabsContent value="availability" className="space-y-6">
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center">
                      <Calendar className="w-5 h-5 text-clinic-blue-600 mr-2" />
                      Available Time Slots
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-4">
                      {provider?.availableDays?.availableDays?.length > 0 ? (
                        provider.availableDays.availableDays.map((dayObj, idx) => (
                          <div key={idx}>
                            <h4 className="font-medium text-gray-900 mb-1">{dayObj.day}</h4>
                            <div className="flex flex-wrap gap-2">
                              {dayObj.shifts?.map((shift, sIdx) => (
                                <span
                                  key={sIdx}
                                  className="px-3 py-1 rounded-md bg-clinic-blue-50 text-clinic-blue-700 text-sm cursor-pointer"
                                >
                                  {shift.startTime} - {shift.endTime}
                                </span>
                              ))}
                            </div>
                          </div>
                        ))
                      ) : (
                        <p className="text-gray-500 italic">No available slots</p>
                      )}
                    </div>
                  </CardContent>
                </Card>
              </TabsContent>

              <TabsContent value="payment" className="space-y-6">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                  <Card className="border-green-200 bg-green-50 flex flex-col">
                    <CardHeader>
                      <CardTitle className="flex items-center">
                        <Shield className="w-5 h-5 text-green-600 mr-2" />
                        Insurance Coverage
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="flex-1 flex flex-col">
                      <p className="text-sm text-gray-600 mb-4">
                        We accept most major insurance plans. Your session fee will be determined by your insurance coverage.
                      </p>
                      <div className="flex flex-wrap gap-2 mb-4">
                        {provider.acceptedInsurance?.map((insurance, index) => (
                          <Badge key={index} variant="outline" className="border-green-200 text-green-700 bg-green-50">
                            {insurance}
                          </Badge>
                        ))}
                      </div>
                      <div className="bg-green-100 rounded-lg p-3 mb-4">
                        <p className="text-xs text-green-600">Insurance verification available before your visit</p>
                      </div>

                      <div className="mt-auto pt-4 border-t border-green-200">
                        <div className="bg-gray-700 text-white rounded-lg p-4 text-center">
                          <p className="text-2xl font-bold">$0-50</p>
                          <p className="text-sm opacity-90">copay per visit</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>

                  <Card className="border-blue-200 bg-blue-50 flex flex-col">
                    <CardHeader>
                      <CardTitle className="flex items-center">
                        <CreditCard className="w-5 h-5 text-blue-600 mr-2" />
                        Private Pay
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="flex-1 flex flex-col">
                      <p className="text-sm text-gray-600 mb-4">
                        Pay directly for sessions without insurance. Competitive rates with flexible payment options.
                      </p>

                      <div className="space-y-3 mb-4">
                        <div className="bg-blue-100 rounded-lg p-4 border border-blue-200 relative">
                          <div className="flex justify-between items-start">
                            <div>
                              <h4 className="font-medium text-gray-900 text-sm">Initial Consultation</h4>
                              <p className="text-xs text-blue-600">60 minutes</p>
                            </div>
                            <div className="text-right">
                              <span className="font-bold text-blue-700 text-xl">$200</span>
                            </div>
                          </div>
                        </div>

                        <div className="bg-blue-100 rounded-lg p-4 border border-blue-200 relative">
                          <div className="flex justify-between items-start">
                            <div>
                              <h4 className="font-medium text-gray-900 text-sm">Follow-up</h4>
                              <p className="text-xs text-blue-600">30 minutes</p>
                            </div>
                            <div className="text-right">
                              <span className="font-bold text-blue-700 text-xl">$120</span>
                            </div>
                          </div>
                        </div>

                        <div className="bg-blue-100 rounded-lg p-4 border border-blue-200 relative">
                          <div className="flex justify-between items-start">
                            <div>
                              <h4 className="font-medium text-gray-900 text-sm">Therapy Session</h4>
                              <p className="text-xs text-blue-600">50 minutes</p>
                            </div>
                            <div className="text-right">
                              <span className="font-bold text-blue-700 text-xl">$180</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="bg-blue-100 rounded-lg p-3 mb-4">
                        <p className="text-xs text-blue-600">Credit cards, HSA/FSA, and payment plans accepted</p>
                      </div>

                      <div className="mt-auto pt-4 border-t border-blue-200">
                        <div className="bg-gray-700 text-white rounded-lg p-4 text-center">
                          <p className="text-2xl font-bold">$120-200</p>
                          <p className="text-sm opacity-90">per session</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>

                  <Card className="border-purple-200 bg-purple-50 flex flex-col">
                    <CardHeader>
                      <CardTitle className="flex items-center">
                        <Calendar className="w-5 h-5 text-purple-600 mr-2" />
                        Subscription Plans
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="flex-1 flex flex-col">
                      <p className="text-sm text-gray-600 mb-4">
                        Choose from our flexible subscription plans designed for ongoing mental health care.
                      </p>

                      <div className="space-y-3 mb-4">
                        <div className="bg-purple-100 rounded-lg p-3 border border-purple-200">
                          <div className="flex justify-between items-center">
                            <div>
                              <h4 className="font-medium text-gray-900 text-sm">Essential</h4>
                              <p className="text-xs text-purple-600">2 sessions/month</p>
                            </div>
                            <span className="font-bold text-purple-700">$149/mo</span>
                          </div>
                        </div>

                        <div className="bg-purple-100 rounded-lg p-3 border-2 border-purple-400 relative">
                          <div className="absolute -top-2 left-3">
                            <span className="bg-purple-600 text-white text-xs px-2 py-1 rounded-full">Popular</span>
                          </div>
                          <div className="flex justify-between items-center">
                            <div>
                              <h4 className="font-medium text-gray-900 text-sm">Comprehensive</h4>
                              <p className="text-xs text-purple-600">Unlimited sessions</p>
                            </div>
                            <span className="font-bold text-purple-700">$299/mo</span>
                          </div>
                        </div>

                        <div className="bg-purple-100 rounded-lg p-3 border border-purple-200">
                          <div className="flex justify-between items-center">
                            <div>
                              <h4 className="font-medium text-gray-900 text-sm">Premium</h4>
                              <p className="text-xs text-purple-600">Everything + family</p>
                            </div>
                            <span className="font-bold text-purple-700">$449/mo</span>
                          </div>
                        </div>

                        <div className="bg-green-100 rounded-lg p-3 border border-green-200">
                          <div className="flex justify-between items-center">
                            <div>
                              <h4 className="font-medium text-gray-900 text-sm">Student</h4>
                              <p className="text-xs text-green-600">Income-based pricing</p>
                            </div>
                            <span className="font-bold text-green-700">$89/mo</span>
                          </div>
                        </div>
                      </div>

                      <div className="bg-purple-100 rounded-lg p-3 mb-4">
                        <p className="text-xs text-purple-600">Cancel anytime • First month 50% off</p>
                      </div>

                      <div className="mt-auto pt-4 border-t border-purple-200">
                        <div className="bg-gray-700 text-white rounded-lg p-4 text-center">
                          <p className="text-2xl font-bold">$299</p>
                          <p className="text-sm opacity-90">per month</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>

                </div>
              </TabsContent>

              <TabsContent value="reviews" className="space-y-6">
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center justify-between">
                      <div className="flex items-center">
                        <ThumbsUp className="w-5 h-5 text-clinic-blue-600 mr-2" />
                        Patient Reviews
                      </div>
                      <div className="flex items-center space-x-2">
                        <Star className="w-4 h-4 fill-current text-yellow-400" />
                        <span className="font-medium">{provider.rating}</span>
                        <span className="text-gray-500">({provider.reviewCount} reviews)</span>
                      </div>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-6">
                      {displayedReviews?.map((review) => (
                        <div key={review.id} className="border-b pb-4 last:border-b-0">
                          <div className="flex items-center mb-2">
                            <div className="flex items-center">
                              {[...Array(5)]?.map((_, i) => (
                                <Star
                                  key={i}
                                  className={`w-4 h-4 ${i < review.rating ? 'fill-current text-yellow-400' : 'text-gray-300'
                                    }`}
                                />
                              ))}
                            </div>
                            <span className="ml-2 text-sm font-medium">{review.patientName}</span>
                            {review.verified && (
                              <Badge variant="secondary" className="ml-2 text-xs bg-green-100 text-green-700">
                                <CheckCircle className="w-3 h-3 mr-1" />
                                Verified
                              </Badge>
                            )}
                            <span className="ml-auto text-xs text-gray-400">
                              {new Date(review.date).toLocaleDateString()}
                            </span>
                          </div>
                          <p className="text-gray-600 leading-relaxed">{review.comment}</p>
                        </div>
                      ))}

                      {provider.reviews?.length > 3 && (
                        <div className="text-center pt-4">
                          <Button
                            variant="outline"
                            onClick={() => setShowAllReviews(!showAllReviews)}
                            className="border-clinic-blue-200 text-clinic-blue-600 hover:bg-clinic-blue-50"
                          >
                            {showAllReviews ? 'Show Less' : `Show All ${provider.reviews?.length} Reviews`}
                          </Button>
                        </div>
                      )}
                    </div>
                  </CardContent>
                </Card>
              </TabsContent>

              <TabsContent value="contact" className="space-y-6">
                <div className="grid gap-6">
                  <Card>
                    <CardHeader>
                      <CardTitle className="flex items-center">
                        <Phone className="w-5 h-5 text-clinic-blue-600 mr-2" />
                        Contact Information
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4">
                      {provider?.phone && (
                        <div className="flex items-center">
                          <Phone className="w-4 h-4 text-gray-400 mr-3" />
                          <div>
                            <p className="font-medium">{provider.phone}</p>
                            {/* <p className="text-xs text-gray-500">Office Phone</p> */}
                          </div>
                        </div>
                      )}

                      {provider?.email && (
                        <div className="flex items-center">
                          <Mail className="w-4 h-4 text-gray-400 mr-3" />
                          <div>
                            <p className="font-medium">{provider.email}</p>
                          </div>
                        </div>
                      )}

                      {provider?.address && (
                        <div className="flex items-start">
                          <MapPin className="w-4 h-4 text-gray-400 mr-3 mt-0.5" />
                          <div>
                            <p className="font-medium">
                              {provider.address.street}, {provider.address.city}, {provider.address.state} - {provider.address.zipCode}, {provider.address.country}
                            </p>
                            {provider.yearsAtLocation ? (
                              <p className="text-xs text-gray-500">
                                Office Location • {provider.yearsAtLocation} years at this location
                              </p>
                            ) : (
                              null
                            )}
                          </div>
                        </div>
                      )}
                    </CardContent>
                  </Card>

                  <Card>
                    <CardHeader>
                      <CardTitle className="flex items-center">
                        <Building className="w-5 h-5 text-clinic-blue-600 mr-2" />
                        Office Environment
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      <div className="grid md:grid-cols-2 gap-4">
                        {provider.officeImages?.map((image, index) => (
                          <div key={index} className="relative overflow-hidden rounded-lg">
                            <img
                              src={image}
                              alt={`Office view ${index + 1}`}
                              className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
                            />
                          </div>
                        ))}
                      </div>
                    </CardContent>
                  </Card>

                  <Card>
                    <CardHeader>
                      <CardTitle className="flex items-center">
                        <Clock className="w-5 h-5 text-clinic-blue-600 mr-2" />
                        Office Hours & Policies
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4">
                      <div>
                        <h4 className="font-medium text-gray-900 mb-2">Standard Office Hours</h4>
                        <div className="text-sm text-gray-600 space-y-1">
                          <p>Monday - Friday: 8:00 AM - 6:00 PM</p>
                          <p>Saturday: 9:00 AM - 2:00 PM</p>
                          <p>Sunday: By appointment only</p>
                        </div>
                      </div>

                      <Separator />

                      <div>
                        <h4 className="font-medium text-gray-900 mb-2">Appointment Policies</h4>
                        <ul className="text-sm text-gray-600 space-y-1">
                          <li>• 24-hour cancellation policy</li>
                          <li>• Telehealth appointments available</li>
                          <li>• Same-day appointments when available</li>
                          <li>• Emergency consultation available</li>
                        </ul>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </TabsContent>

            </Tabs>
          </div>
        </div>
      </div>

      <Dialog open={showBookingDialog} onOpenChange={setShowBookingDialog}>
        <DialogContent
          className="!max-w-md !w-[450px] !mx-auto p-4"
          style={{
            maxWidth: '450px !important',
            width: '450px !important',
            fontSize: '14px'
          }}
        >
          <DialogHeader className="pb-2">
            <DialogTitle className="!text-base !font-medium">Book Appointment</DialogTitle>
            <DialogDescription className="!text-xs text-gray-600">
              {selectedDay && selectedTime && `${selectedDay} at ${selectedTime}`}
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-3" style={{ fontSize: '14px' }}>
            <div className="border-b pb-3 mb-3">
              <h4 className="!text-xs font-medium text-gray-700 mb-2">Client Information</h4>
              <div className="grid grid-cols-2 gap-2">
                <div>
                  <Label htmlFor="client-name" className="!text-xs mb-1 block">Full Name</Label>
                  <Input
                    id="client-name"
                    placeholder="Enter full name"
                    value={clientName}
                    onChange={(e) => setClientName(e.target.value)}
                    className="!h-8 !text-xs"
                    style={{ fontSize: '12px' }}
                  />
                </div>
                <div>
                  <Label htmlFor="client-email" className="!text-xs mb-1 block">Email Address</Label>
                  <Input
                    id="client-email"
                    type="email"
                    placeholder="Enter email"
                    value={clientEmail}
                    onChange={(e) => setClientEmail(e.target.value)}
                    className="!h-8 !text-xs"
                    style={{ fontSize: '12px' }}
                  />
                </div>
                <div>
                  <Label htmlFor="client-phone" className="!text-xs mb-1 block">Phone Number</Label>
                  <Input
                    id="client-phone"
                    type="tel"
                    placeholder="(555) 123-4567"
                    value={clientPhone}
                    onChange={(e) => setClientPhone(e.target.value)}
                    className="!h-8 !text-xs"
                    style={{ fontSize: '12px' }}
                  />
                </div>
                <div>
                  <Label htmlFor="client-dob" className="!text-xs mb-1 block">Date of Birth</Label>
                  <Input
                    id="client-dob"
                    type="date"
                    value={clientDOB}
                    onChange={(e) => setClientDOB(e.target.value)}
                    className="!h-8 !text-xs"
                    style={{ fontSize: '12px' }}
                  />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              <div>
                <Label htmlFor="appointment-type" className="!text-xs mb-1 block">Appointment Type</Label>
                <Select value={appointmentType} onValueChange={setAppointmentType}>
                  <SelectTrigger className="!h-8 !text-xs">
                    <SelectValue placeholder="Select type" />
                  </SelectTrigger>
                  <SelectContent>
                    {appointmentTypes?.map((type) => (
                      <SelectItem key={type.value} value={type.value} className="!text-xs">
                        <div className="flex justify-between w-full">
                          <span>{type.label}</span>
                          <span className="text-clinic-blue-600 ml-2">{type.price}</span>
                        </div>
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div>
                <Label htmlFor="payment-type" className="!text-xs mb-1 block">Payment Type</Label>
                <Select value={paymentType} onValueChange={setPaymentType}>
                  <SelectTrigger className="!h-8 !text-xs">
                    <SelectValue placeholder="Select payment" />
                  </SelectTrigger>
                  <SelectContent>
                    {paymentTypes?.map((type) => (
                      <SelectItem key={type.value} value={type.value} className="!text-xs">
                        {type.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </div>

            <div>
              <Label htmlFor="state" className="!text-xs mb-1 block">State (Location)</Label>
              <Select value={selectedState} onValueChange={setSelectedState}>
                <SelectTrigger className="!h-8 !text-xs">
                  <SelectValue placeholder="Select state" />
                </SelectTrigger>
                <SelectContent className="max-h-48">
                  {usStates?.map((state) => (
                    <SelectItem key={state.value} value={state.value} className="!text-xs">
                      {state.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label htmlFor="reason" className="!text-xs mb-1 block">Reason for Visit</Label>
              <Textarea
                id="reason"
                placeholder="Brief description..."
                value={reasonForVisit}
                onChange={(e) => setReasonForVisit(e.target.value)}
                className="!h-12 !text-xs resize-none"
                style={{ fontSize: '12px' }}
              />
            </div>

            <div className="flex gap-2 pt-1">
              <Button
                variant="outline"
                onClick={() => setShowBookingDialog(false)}
                className="flex-1 !h-8 !text-xs !px-3"
                style={{ fontSize: '12px' }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleBookAppointment}
                disabled={!appointmentType || !paymentType || !selectedState || !clientName || !clientEmail || !clientPhone || !clientDOB || loading}
                className="flex-1 !h-8 !text-xs !px-3 bg-clinic-blue-600 hover:bg-clinic-blue-700"
                style={{ fontSize: '12px' }}
              >
                {loading ? 'Creating Account...' : 'Create Account & Book'}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default ProviderViewDetails;